<template>
  <div>
    <list :list="list" />
    <div class="page-box-content" style="text-align:center">
      <Page 
        :current.sync="where.page" 
        :total="total" 
        :page-size="size" 
        @on-change="getData" 
        show-total 
        show-elevator 
      />
    </div>
  </div>
</template>
<script>
import List from './list'
import { bill } from '@/api/user';

export default {
  components:{
    List
  },
  data() {
    return {
      list: [],
      total: 0,
      size: 0,
      where: {
        page: 1
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      bill(this.where).then(res => {
        this.list = res.data
        this.where.page = res.current_page
        this.total = res.total
        this.size = res.per_page
      })
    }
  },
};
</script>